// extracted by mini-css-extract-plugin
export default {"root":"_2YkH7PISLj1FnRDpzniEHf","content":"_2ZXX_HqZB42inYxKL31SPy","snapToBottom":"_3yaF5sP-Jg_i-5jM1IfpvU","inner":"_1tuXmjOaCEMSv4bEDGJXzl"};